import { IConfigsType } from '../../types'

const demo: IConfigsType = {
  'ghai_pop-only-for-qa': {
    '/:brand/product': {
      disableAutoMargin: true,
      feV2: {
        type: 'FE V2',
        configPath: 'ghai_pop/product',
      },
    },
  },
}

export default demo
